module.exports = __webpack_public_path__ + "img/tasty-hemp-oil-softgels.108f4df6.jpg";